wbApp.filter('emailCategory', ['$translate', function ($translate) {
    return function (input) {
        switch (input) {
            case 1:
                return $translate.instant('TXT_VAL_EMAIL_CATEGORY_DEFAULT');
            case 2:
                return $translate.instant('TXT_VAL_EMAIL_CATEGORY_SEASON_TICKET');
            case 3:
                return $translate.instant('TXT_VAL_EMAIL_CATEGORY_MULTI_ATTEND');
            case 4:
                return $translate.instant('TXT_VAL_EMAIL_CATEGORY_ALTERNATIVE_1');
            case 5:
                return $translate.instant('TXT_VAL_EMAIL_CATEGORY_ALTERNATIVE_2');
            case 6:
                return $translate.instant('TXT_VAL_EMAIL_CATEGORY_ALTERNATIVE_3');
            case 7:
                return $translate.instant('TXT_VAL_EMAIL_CATEGORY_ALTERNATIVE_4');
            case 8:
                return $translate.instant('TXT_VAL_EMAIL_CATEGORY_ALTERNATIVE_5');
            case 9:
                return $translate.instant('TXT_VAL_EMAIL_CATEGORY_ALTERNATIVE_6');
            case 10:
                return $translate.instant('TXT_VAL_EMAIL_CATEGORY_ALTERNATIVE_7');
            case 11:
                return $translate.instant('TXT_VAL_EMAIL_CATEGORY_ALTERNATIVE_8');
            case 12:
                return $translate.instant('TXT_VAL_EMAIL_CATEGORY_ALTERNATIVE_9');
            case 13:
                return $translate.instant('TXT_VAL_EMAIL_CATEGORY_ALTERNATIVE_10');
                
            default:
                return '';
        }
    };
}]);